import useMutateApi from '@hooks/useMutateApi';
import type {PropsWithChildren} from 'react';
import {useRef} from 'react';

import {createBackgroundTasksStore} from './store';
import type {BackgroundTasksStoreApi, Task} from './types';
import {BackgroundTasksContext} from './useBackgroundTasks';

export const BackgroundTasksProvider = (props: PropsWithChildren) => {
  const {children} = props;
  const {trigger: subscribeApiService} = useMutateApi(`publicSubscribeToBackgroundTask`);
  const {trigger: subscribeQueryService} = useMutateApi(`publicSubscribeToBackgroundTask1`);

  const subscribe = async (taskId: string, target?: Task['subscribeTarget']) =>
    target === `query-service` ? subscribeQueryService({task_id: taskId}) : subscribeApiService({task_id: taskId});

  const storeRef = useRef<BackgroundTasksStoreApi>(createBackgroundTasksStore({subscribe}));

  return <BackgroundTasksContext.Provider value={storeRef.current}>{children}</BackgroundTasksContext.Provider>;
};
